/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 2.52 PM
 */

import { api, apiv2 } from 'utils/index';

const defaultState = { items: [], errors: null };
const baseUrl = 'categories';
const model = {
    name: 'category',
    state: defaultState,
    reducers: {
        reset: (state) => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({ ...state, items: payload.data }),
        putResponse: (state, payload) => ({ ...state }),
    },
    effects: {
        async fetch(params) {
            await apiv2.get(baseUrl, { params: { ...params } })
                .then((response) => this.fetchResponse(response));
        },
        async put({ categoryId, ...data }) {
            await api.put(`${baseUrl}/${categoryId}`, data, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then((response) => this.putResponse(response));
        },
    },
};

export default model;
